var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgRefundAmount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_493_193259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.25V0.750002H0.75V19.25H19.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_493_193259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 8.59375C7.73082 8.59375 7.03125 7.89418 7.03125 7.03125C7.03125 6.16832 7.73082 5.46875 8.59375 5.46875C9.45668 5.46875 10.1562 6.16832 10.1562 7.03125",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 8.59375C9.45668 8.59375 10.1562 9.29332 10.1562 10.1563C10.1562 11.0192 9.45668 11.7188 8.59375 11.7188C7.73082 11.7188 7.03125 11.0192 7.03125 10.1563",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 3.90625V5.46875",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 11.7188V13.2812",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 19.2188H16.875C18.1694 19.2188 19.2187 18.1694 19.2187 16.875C19.2187 15.5806 18.1694 14.5313 16.875 14.5313H12.9688",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 16.0938L12.9688 14.5313L14.5312 12.9688",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2487 16.2306C9.71527 16.3457 9.1616 16.4062 8.59375 16.4062C4.27902 16.4062 0.78125 12.9085 0.78125 8.59375C0.78125 4.27902 4.27902 0.781251 8.59375 0.781251C12.9085 0.781251 16.4062 4.27902 16.4062 8.59375C16.4062 9.12887 16.3525 9.65141 16.25 10.1563",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgRefundAmount);
export default __webpack_public_path__ + "static/media/svg_refund_amount.24c23261713806d60ccc25b3ec3758b2.svg";
export { ForwardRef as ReactComponent };